// src/lib/useSocket.js
import { useEffect, useRef, useCallback } from "react";
import { socketService } from "@/Services/socketService";

/**
 * token: auth token string
 * onConnected: callback when socket connects
 */
export const useSocket = (token, { onConnected } = {}) => {
    const socketRef = useRef(null);

    useEffect(() => {
        socketRef.current = socketService.connect(token, onConnected);
        return () => {
            // intentionally do not disconnect on component unmount
        };
    }, [token, onConnected]);

    const emit = useCallback((eventName, data) => {
        return socketService.emit(eventName, data);
    }, []);

    const on = useCallback((eventName, callback) => {
        socketService.on(eventName, callback);
        return () => socketService.off(eventName, callback);
    }, []);

    const off = useCallback((eventName, callback) => {
        socketService.off(eventName, callback);
    }, []);

    return {
        socket: socketRef.current,
        emit,
        on,
        off,
        joinSession: socketService.joinSession.bind(socketService),
        leaveSession: socketService.leaveSession.bind(socketService),
        isConnected: socketService.isSocketConnected(),
        socketId: socketService.getSocketId(),
    };
};